import {
  FlagDeu,
  FlagEng,
  FlagFra,
  FlagIta,
  FlagQms,
  FlagSpa,
} from '@lessonnine/design-system.lib';

export const learnLanguages = {
  de: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Englisch',
    },
    {
      code: 'SPA',
      Icon: FlagSpa,
      name: 'Spanisch',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'Französisch',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italienisch',
    },
  ],
  en: [
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'German',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'French',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italian',
    },
    {
      code: 'QMS',
      Icon: FlagQms,
      name: 'Spanish',
    },
  ],
  es: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Inglés',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Alemán',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'Francés',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italiano',
    },
  ],
  fr: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Anglais',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Allemand',
    },
    {
      code: 'SPA',
      Icon: FlagSpa,
      name: 'Espagnol',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italien',
    },
  ],
  it: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Inglese',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Tedesco',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'Francese',
    },
    {
      code: 'SPA',
      Icon: FlagSpa,
      name: 'Spagnolo',
    },
  ],
  pl: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Angielski',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Niemiecki',
    },
  ],
  pt: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Inglês',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Alemão',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italiano',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'Francês',
    },
    {
      code: 'SPA',
      Icon: FlagSpa,
      name: 'Espanhol',
    },
  ],
  sv: [
    {
      code: 'ENG',
      Icon: FlagEng,
      name: 'Engelska',
    },
    {
      code: 'ITA',
      Icon: FlagIta,
      name: 'Italienska',
    },
    {
      code: 'DEU',
      Icon: FlagDeu,
      name: 'Tyska',
    },
    {
      code: 'FRA',
      Icon: FlagFra,
      name: 'Franska',
    },
    {
      code: 'SPA',
      Icon: FlagSpa,
      name: 'Spanska',
    },
  ],
};

export const displayedLanguage = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  pl: 'Polski',
  pt: 'Português',
  sv: 'Svenska',
};

export const defaultLearnLanguageMap = {
  default: 'ENG',
  en: 'QMS',
};

export const getDefaultLearnLanguage = (locale) =>
  defaultLearnLanguageMap[locale] ?? defaultLearnLanguageMap.default;

export const getSortedLearnLanguages = (locale) => {
  const defaultLearnLanguage = getDefaultLearnLanguage(locale);
  return learnLanguages[locale].sort(({ code }) => (code === defaultLearnLanguage ? -1 : 1));
};
